import anime from "animejs";
export default class Referral {
    constructor(element) {
        this.element = document.querySelector(element);
        if (!this.element) return;
        this.detail = document.querySelector(".referral__detail");
        this.row = document.querySelector(".referral__row");
        this.closing_overlay = document.querySelector(
            ".referral__closing-overlay"
        );
        this.form = document.querySelector(".referral-form");
        this.btn = document.querySelector(".referral__btn");
        this.bindEvents();
        this.init();
    }
    bindEvents() {
        this.element.addEventListener("click", e => this.showDetail(e));
        this.closing_overlay.addEventListener("click", e => this.hideDetail(e));
        if (window.location.pathname.split("/")[2] == "sell-your-brand") {
            this.btn.addEventListener("click", e => this.openForm(e));
        }
    }
    init() {
        if (window.location.hash == "#referral-reward") return;
        setTimeout(() => {
            anime({
                targets: this.element,
                opacity: [0, 1],
                easing: "linear",
                left: 0
            });
        }, 5000);
    }
    openForm(e) {
        e.preventDefault();
        this.form.classList.add("referral-form--active");
        this.closing_overlay.classList.add("referral-form--active-close");
        this.hideDetail(e, true);
    }
    showDetail(e) {
        this.closing_overlay.classList.add("referral__closing-overlay--active");

        let tl = anime.timeline({
            easing: "linear",
            duration: 150
        });
        tl.add({
            targets: this.element,
            opacity: [1, 0]
        })
            .add({
                targets: this.detail,
                width: "100%",
                opacity: [0, 1],
                begin: anim => {
                    anim.animatables[0].target.classList.add(
                        "referral__detail--active"
                    );
                }
            })
            .add({
                targets: this.row,
                delay: 180,
                opacity: [0, 1]
            });
    }
    hideDetail(e, hideIcon) {
        this.closing_overlay.classList.remove(
            "referral__closing-overlay--active"
        );

        let tl = anime.timeline({
            easing: "easeOutSine",
            duration: 150
        });
        tl.add({
            targets: this.row,
            opacity: [1, 0]
        })
            .add({
                targets: this.detail,
                delay: 100,
                opacity: [1, 0],
                width: "0px",
                complete: anim => {
                    anim.animatables[0].target.classList.remove(
                        "referral__detail--active"
                    );
                }
            })
            .add({
                targets: this.element,
                delay: 450,
                opacity: [0, 1],
                begin: anim => {
                    if (hideIcon) {
                        anim.animatables[0].target.classList.add(
                            "referral--hide"
                        );
                    }
                }
            });
    }
}
